import ContactMailIcon from "@mui/icons-material/ContactMail";
import CancelIcon from "@mui/icons-material/Cancel";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import ParaglidingIcon from "@mui/icons-material/Paragliding";
import SchoolIcon from "@mui/icons-material/School";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import BuildIcon from "@mui/icons-material/Build";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BrushIcon from "@mui/icons-material/Brush";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Link,
  List,
  Typography,
} from "@mui/material";
import { useState, type ReactNode } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux/store";
import CustomDrawerItem from "./CustomDrawerItem";
import DrawerFooter from "./DrawerFooter";
import LoginDialog from "../../../../common/LoginDialog";
import { closeDrawer } from "../../../../../redux/features/drawer/drawerSlice";
import { logout } from "../../../../../redux/features/auth/authSlice";
import navigationRoutes from "../Navbar/navigation";

const ICON_MAP: Record<string, ReactNode> = {
  Formación: <SchoolIcon sx={{ color: "white" }} />,
  Experiencia: <DeveloperModeIcon sx={{ color: "white" }} />,
  Habilidades: <ParaglidingIcon sx={{ color: "white" }} />,
  Plantilla: <BrushIcon sx={{ color: "white" }} />,
  "CURP Generator": <BuildIcon sx={{ color: "white" }} />,
  CLABE: <AccountBalanceIcon sx={{ color: "white" }} />,
};

function AppDrawer() {
  const { open } = useAppSelector((state) => state.drawer);
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const [loginOpen, setLoginOpen] = useState(false);

  const handleClose = () => {
    dispatch(closeDrawer());
  };

  const handleButton = (route: string) => {
    dispatch(closeDrawer());
    console.log(`Dirigir a ruta: ${route}`);
  };

  const visibleRoutes = navigationRoutes.filter(
    (nav) => !nav.protected || isAuthenticated
  );

  return (
    <>
    <Drawer anchor="left" open={open} onClose={handleClose}>
      <Box
        px={1}
        width={{ xs: "80vw", sm: "50vw", md: 270, lg: 290 }}
        height="100%"
        sx={{
          background: `linear-gradient(180deg, #0B2845 0.24%, #1B2651 105.85%)`,
        }}
        display="flex"
        flexDirection="column"
      >
        <Box
          mt={2}
          display="flex"
          justifyContent="center"
          onClick={handleClose}
          sx={{ cursor: "pointer" }}
          flexDirection="row"
        >
          <Box flex={1} ml={3}>
            <Link href="/#perfil">
              <Button variant="text" sx={{ color: "white" }}>
                <Typography variant="body1" fontWeight="bold" color={"white"}>
                  ZavalGT
                </Typography>
              </Button>
            </Link>
          </Box>
          <Box
            mr={3}
            display="flex"
            justifyContent="center"
            alignContent="center"
            alignItems="center"
          >
            <CancelIcon sx={{ color: "white" }} />
          </Box>
        </Box>
        <Box flex={1}>
          <Box>
            <List>
              {visibleRoutes.map((nav) => (
                <Link key={nav.route} href={nav.route}>
                  <CustomDrawerItem
                    handleButton={() => handleButton(nav.route)}
                    title={nav.title}
                    icon={
                      ICON_MAP[nav.title] ?? (
                        <ContactMailIcon sx={{ color: "white" }} />
                      )
                    }
                  />
                </Link>
              ))}
              <Link href="/#contactar">
                <CustomDrawerItem
                  handleButton={() => handleButton("/#contactar")}
                  title="Contactar"
                  icon={<ContactMailIcon sx={{ color: "white" }} />}
                />
              </Link>
            </List>
            <Divider sx={{ borderColor: "rgba(255,255,255,0.15)", mx: 2 }} />
            <Box px={2} py={1}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={
                  isAuthenticated ? (
                    <LogoutIcon fontSize="small" />
                  ) : (
                    <LoginIcon fontSize="small" />
                  )
                }
                onClick={() => {
                  if (isAuthenticated) {
                    dispatch(logout());
                  } else {
                    setLoginOpen(true);
                  }
                  handleClose();
                }}
                sx={{
                  color: "white",
                  borderColor: "rgba(255,255,255,0.3)",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "white",
                    bgcolor: "rgba(255,255,255,0.1)",
                  },
                }}
              >
                {isAuthenticated ? "Cerrar sesión" : "Iniciar sesión"}
              </Button>
            </Box>
          </Box>
        </Box>
        <DrawerFooter />
      </Box>
    </Drawer>
    <LoginDialog open={loginOpen} onClose={() => setLoginOpen(false)} />
    </>
  );
}

export default AppDrawer;
